export const VariousConsts = {
	ASC: "asc",
	DESC: "desc",
	ALL: "all",
	YES: "yes",
	NO: "no",
	NOT_AVAILABLE: "",
};
